// src/routes/AdminRoutes.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";                    // ← Added this import
import { useAuth } from "../context/AuthContext";

import Auth from "../pages/Auth";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

import Dashboard from "../pages/Dashboard";
import SuperAdminTable from "../components/SuperAdminTable";
import OrganizationTable from "../components/OrganizationTable";
import TransactionsTable from "../components/TransactionsTable";
import Settings from "../pages/Settings";

function MainLayout({ activePage, setActivePage }) {
  const { userName, logout } = useAuth();

  return (
    <div className="flex h-screen overflow-hidden bg-bg-black text-text-white">
      <Sidebar 
        active={activePage} 
        onItemClick={setActivePage} 
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          name={userName} 
          onLogout={logout} 
        />
        
        <main className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/super-admin" element={<SuperAdminTable />} />
            <Route path="/organization" element={<OrganizationTable />} />
            <Route path="/transactions" element={<TransactionsTable />} />
            <Route path="/settings" element={<Settings />} />
            
            <Route path="*" element={
              <div className="flex items-center justify-center h-full text-2xl text-text-muted">
                Coming soon...
              </div>
            } />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function AdminRoutes() {
  const { isLoggedIn, loading } = useAuth();
  const [activePage, setActivePage] = useState("Overview");

  if (loading) {
    return (
      <div className="min-h-screen bg-bg-black flex items-center justify-center text-white">
        Loading...
      </div>
    );
  }

  return (
    <Routes>
      {/* Public Auth Route */}
      <Route 
        path="/auth" 
        element={isLoggedIn ? <Navigate to="/" replace /> : <Auth />} 
      />

      {/* Protected Routes */}
      <Route 
        path="/*" 
        element={
          isLoggedIn ? (
            <MainLayout 
              activePage={activePage} 
              setActivePage={setActivePage} 
            />
          ) : (
            <Navigate to="/auth" replace />
          )
        } 
      />
    </Routes>
  );
}